export { default } from './DialogContent';